// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___b4Kc-","open":"open___3pYkl","userIcon":"userIcon___1Ppkh"};